import { useGetAllPortfoliosValueOverview } from 'ClientPortal/src/api/Queries/value-overview'
import { isEmpty } from 'lodash'

export function useAssetListPageData() {
    const { multiPortfolioValueOverview, isMultiPortfolioValueOverviewPending } = useGetAllPortfoliosValueOverview({
        throwOnError: true,
        retry: false,
    })

    const getAssetsPerPortfolio = () =>
        multiPortfolioValueOverview?.portfolios
            .map(({ title, uuid, closing_date, assets, type }) => ({
                type,
                title,
                uuid,
                closing_date,
                assets,
            }))
            .filter((portfolio) => !isEmpty(portfolio.assets)) || []

    return {
        multiPortfolioValueOverview,
        isMultiPortfolioValueOverviewLoading: isMultiPortfolioValueOverviewPending,
        getAssetsPerPortfolio,
    }
}
